/**
 * Signup page — wraps SignupForm with auth context integration
 */

import React, { useState } from 'react';
import { useNavigate, Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import SignupForm from '../components/SignupForm';

const SignupPage: React.FC = () => {
  const { isAuthenticated, isLoading, signup } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState<string | undefined>(undefined);
  const [submitting, setSubmitting] = useState(false);

  // Show nothing while the auth context is still initialising
  if (isLoading) {
    return (
      <div
        style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <p style={{ color: '#666' }}>Loading...</p>
      </div>
    );
  }

  // If already authenticated, redirect home
  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  const handleSubmit = async (
    email: string,
    password: string,
    displayName?: string
  ) => {
    setSubmitting(true);
    setError(undefined);

    try {
      await signup(email, password, displayName);
      navigate('/');
    } catch (err: any) {
      const message =
        err.response?.data?.detail ||
        err.message ||
        'Sign up failed. Please try again.';
      setError(message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <SignupForm
      onSubmit={handleSubmit}
      error={error}
      isLoading={submitting}
    />
  );
};

export default SignupPage;
